import { trigger, TriggerContent } from "./trigger";

export const Rewards = {
  TriggerContent,
  trigger,
};
